var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',[_c('Row'),_c('TablePaginate',{attrs:{"columns":_vm.columns,"data":_vm.products,"loading":_vm.loading,"meta":_vm.meta,"changePage":_vm.changePage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }